var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLeftServerOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77254 8C5.77254 7.0111 6.06578 6.0444 6.61519 5.22215C7.1646 4.39991 7.94549 3.75904 8.85912 3.3806C9.77275 3.00217 10.7781 2.90315 11.748 3.09608C12.7179 3.289 13.6088 3.76521 14.3081 4.46447C15.0073 5.16373 15.4835 6.05465 15.6765 7.02455C15.8694 7.99446 15.7704 8.99979 15.3919 9.91342C15.0135 10.827 14.3726 11.6079 13.5504 12.1573C12.7281 12.7068 11.7614 13 10.7725 13H5.27254C4.77626 12.9994 4.28579 12.8932 3.83367 12.6886C3.38155 12.484 2.97811 12.1855 2.65013 11.8131C2.32216 11.4406 2.07713 11.0027 1.93133 10.5283C1.78552 10.0539 1.74226 9.55399 1.80442 9.06162C1.86658 8.56925 2.03274 8.09573 2.29187 7.67248C2.551 7.24923 2.89717 6.88593 3.30743 6.60668C3.71768 6.32743 4.18263 6.13861 4.67142 6.05277C5.16022 5.96692 5.66168 5.986 6.14254 6.10875",
    stroke: "#131313",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27246 8.5L9.77246 10L12.7725 7",
    stroke: "#343330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftServerOn);
export default __webpack_public_path__ + "static/media/Icon Left (Server ON).81ee158aca2edc7045da605e7ebd236a.svg";
export { ForwardRef as ReactComponent };